export enum UpdateStatusProgress {
  StatusSelection,
  DecisionByLoginEntry,
  DlsReferralFormEntry,
}
